import { useState } from 'react'
import copy from "copy-to-clipboard";
import QRCode from 'react-qr-code'
import axios from "axios";
import { HiShare } from "react-icons/hi"
import { AiOutlinePlus } from "react-icons/ai"

import copy_icon from "../assets/Icon feather-copy.png"
import delet from "../assets/delete.png"
import plus_btn from "../assets/plus-btn.png"
import arrows from "../assets/convert.png"
import matic from "../assets/matic-com.png"
import gbp from "../assets/gbp-com.png"
import QR_code from "../assets/Group 1195.png"
import facebook from "../assets/facebook.png"
import instagram from "../assets/instagram.png"
import whatsapp from "../assets/whatsapp.png"
import twitter from "../assets/twitter.png"
import mail from "../assets/mail.png"
import UserModal from '../components/Modal'

import { GET_WALLETS, ADD_WALLET, DELETE_WALLET, GET_MATIC_AMMOUNT } from "../helpers/api"
import { useEffect } from 'react';


import { EmailShareButton, FacebookShareButton, TwitterShareButton, WhatsappShareButton } from "react-share";




function Wallet(props) {
    const [modalItem, setModalItem] = useState("");
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = (modalItemValue) => { setShow(true); setModalItem(modalItemValue) };



    // copy-text-to-the-clipboard
    const [copyText, setCopyText] = useState('');
    const copyToClipboard = (copyText) => {
        copy(copyText);
        alert("Copied to clipboard")
    }



    const [wallet, Setwallet] = useState([])

    const getwallets = async () => {
        try {
            const response = await GET_WALLETS()
            console.log("response", response);
            Setwallet(response.message)
        }
        catch (e) {
            console.log(e);
        }
    }


    const deletewallet = async (id) => {
        try {
            const response = await DELETE_WALLET(id)
            getwallets()
        }
        catch (e) {
            console.log(e);
        }
    }


    const [newwallet, setNewWallet] = useState({ wtADRS: "" })

    const handlewallet = (event) => {
        setNewWallet({ ...newwallet, wtADRS: event.target.value })
    }

    const addwallet = async () => {
        try {
            const payload = {
                walletaddress: newwallet.wtADRS
            }
            const response = await ADD_WALLET(payload)
            getwallets()
        }
        catch (e) {
            console.log(e);
        }
    }




    useEffect(() => {
        getwallets()
    }, [])





    // await axios.get(`http://api.binance.com/api/v3/ticker/price?symbol=MATICUSDT`)


    const [maticAmount, setMaticAmount] = useState('');
    const [usdtAmount, setUsdtAmount] = useState('');

    const handleMaticInputChange = (event) => {
        const maticValue = event.target.value;
        setMaticAmount(maticValue);
        const usdtValue = parseFloat(maticValue) * 0.55;
        setUsdtAmount(usdtValue.toFixed(2));
    };

    const handleUsdtInputChange = (event) => {
        const usdtValue = event.target.value;
        setUsdtAmount(usdtValue);
        const maticValue = parseFloat(usdtValue) / 0.55;
        setMaticAmount(maticValue.toFixed(2));
    };



    const shareUrl = ""

    const [selectwallet, setSelectwallet] = useState({ address: "" })

    const selectwalletaddress = (e) => {
        try {

            console.log(e);
            setSelectwallet({ ...selectwallet, address: e })
        }
        catch (e) {
            console.log(e);
        }
    }

    return (
        <>
            <section className='wallet_sec'>
                <div className="container">
                    <div className="card jc-center text-center">
                        {/* <h3>Wallet</h3> */}
                        <div className="content">
                            <div className='d-flex jc-center mb-4'>
                                <div className="form-inline d-flex ai-center me-3">
                                    <div className="dropdown">


                                        <button placeholder='0x6ac64618d6c82c1e51836658F9ca958' className="btn dropdown-toggle hash-tag text-truncate" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            {selectwallet?.address ? selectwallet?.address : "0x6ac64618d6c82c1e51836658F9ca958"}
                                        </button>
                                        <div className="dropdown-menu" style={{ width: "100%" }} aria-labelledby="dropdownMenuButton">
                                            {
                                                wallet.map((item, i) => (

                                                    <div className='d-flex ai-center' key={i}>
                                                        <a onClick={() => selectwalletaddress(item?.walletaddress)} className="dropdown-item hash-tag text-truncate" href="#">
                                                            {item?.walletaddress}
                                                        </a>
                                                        <button className='btn copy_icon' onClick={() => copyToClipboard(item?.walletaddress)}>
                                                            <img src={copy_icon} alt="icon" className='img-fluid' />
                                                        </button>
                                                        <button onClick={() => deletewallet(item?._id)} className='btn delet_icon'>
                                                            <img src={delet} alt="icon" className='img-fluid' />
                                                        </button>
                                                    </div>
                                                ))
                                            }
                                        </div>

                                        {/* <select className="btn dropdown-toggle hash-tag text-truncate" aria-label="Default select example">

                                            {wallet.map((item, i) =>
                                            (
                                                <option value={item?.walletaddress} key={i}>
                                                    <div className='d-flex ai-center' >
                                                        <a className="dropdown-item hash-tag text-truncate" href="#">
                                                            {item?.walletaddress}
                                                        </a>
                                                        <button className='btn copy_icon' onClick={() => copyToClipboard(item?.walletaddress)}>
                                                            <img src={copy_icon} alt="icon" className='img-fluid' />
                                                        </button>
                                                        <button onClick={() => deletewallet(item?._id)} className='btn delet_icon'>
                                                            <img src={delet} alt="icon" className='img-fluid' />
                                                        </button>
                                                    </div>
                                                </option>

                                            )
                                            )}



                                        </select> */}

                                    </div>
                                    {/* <input type="text" className='form-control' value="0x6ac64618d6c82c1e..." disabled />
                                    <button className='btn' onClick={() => copyToClipboard("0x6ac64618d6c82c1e51836658F9ca95885443e1cw")}>
                                        <img src={copy_icon} alt="icon" className='img-fluid' />
                                    </button> */}
                                </div>
                                {
                                    // modalItem == "+" &&
                                    <UserModal btnText="+" id="+" icon={<AiOutlinePlus />} customClasses="plus_btn me-3" modalItem={modalItem} show={show} handleClose={handleClose} handleShow={handleShow} >
                                        <div className='text-center mb-4'>
                                            <h3>Add New Wallet</h3>
                                        </div>
                                        <div className='mb-5'>
                                            <div className="mb-3">
                                                <label className="form-label">Enter Walet</label>
                                                <input type="text" className="form-control" value={newwallet.wtADRS} onChange={(e) => handlewallet(e)} placeholder='Enter here' />
                                            </div>
                                        </div>
                                        <div className='modal_btn jc-center text-center'>
                                            <button className='btn deposit_btn' onClick={() => addwallet()}>Add Now</button>
                                        </div>
                                    </UserModal>
                                }
                                {
                                    // modalItem == "Share" &&
                                    <UserModal btnText="Share" title="Wallet Address" id="Share" icon={<HiShare />} customClasses="share_btn" modalItem={modalItem} show={show} handleClose={handleClose} handleShow={handleShow} >
                                        <div className='wallet_address_modal text-center'>
                                            <h3 className='mb-5'>Wallet Address</h3>
                                            <div className='mb-4'>
                                                {/* <img src={QR_code} alt="image" className='img-fluid mb-3' /> */}
                                                <QRCode
                                                    size={256}
                                                    style={{ height: "auto", maxWidth: "100%", width: "50%" }}
                                                    value={selectwallet?.address ? selectwallet?.address : "0x6ac64618d6c82c1e51836658F9ca958"}
                                                    viewBox={`0 0 256 256`}
                                                />
                                                <p>Scan QR to copy the wallet address</p>
                                            </div>
                                            <div className="form-inline d-flex ai-center me-3 mb-4">
                                                <input type="text" className='form-control' value={selectwallet?.address ? selectwallet?.address : "0x6ac64618d6c82c1e51836658F9ca958"} />
                                                <button className='btn' onClick={() => copyToClipboard(selectwallet?.address ? selectwallet?.address : "0x6ac64618d6c82c1e51836658F9ca958")}>
                                                    <img src={copy_icon} alt="icon" className='img-fluid' />
                                                </button>
                                            </div>
                                            <div>
                                                <p>Share wallet address</p>
                                                <div className="social">

                                                    <FacebookShareButton
                                                        title={selectwallet?.address}
                                                        url={"https://google.com"}
                                                        // url={selectwallet?.address}
                                                        // quote={"google link share"}
                                                        // hashtag={"#hashtag"}
                                                        description={"google share description"}
                                                        className="Demo__some-network__share-button"

                                                    >
                                                        <img src={facebook} alt="image" className='img-fluid me-2' />
                                                    </FacebookShareButton>

                                                    <TwitterShareButton
                                                        title={selectwallet?.address}
                                                        url={"https://google.com"}
                                                        quote={"google link share"}
                                                        hashtag={"#hashtag"}
                                                        description={"google share description"}
                                                        className="Demo__some-network__share-button"
                                                    >
                                                        <img src={twitter} alt="image" className='img-fluid me-2' />
                                                    </TwitterShareButton>

                                                    <WhatsappShareButton

                                                        title={selectwallet?.address}
                                                        url={"https://google.com"}
                                                        quote={"google link share"}
                                                        hashtag={"#hashtag"}
                                                        description={"google share description"}
                                                        className="Demo__some-network__share-button"

                                                    >
                                                        <img src={whatsapp} alt="image" className='img-fluid me-2' />
                                                    </WhatsappShareButton>

                                                    <EmailShareButton
                                                        title={selectwallet?.address}
                                                        url={"https://google.com"}
                                                        quote={"google link share"}
                                                        hashtag={"#hashtag"}
                                                        description={"google share description"}
                                                        className="Demo__some-network__share-button"

                                                    >
                                                        <img src={mail} alt="image" className='img-fluid' />

                                                    </EmailShareButton>

                                                    {/* <img src={instagram} alt="image" className='img-fluid me-2' /> */}

                                                </div>
                                            </div>
                                        </div>
                                    </UserModal>
                                }
                            </div>
                            <h4>4.2288 MATIC</h4>
                            <h6>£ 4.24 GBP</h6>
                            <div className='d-flex jc-center mb-4'>
                                {
                                    // modalItem == "Deposit" &&
                                    <UserModal btnText="Deposit" id="Deposit" customClasses="deposit_btn me-4" modalItem={modalItem} show={show} handleClose={handleClose} handleShow={handleShow} >
                                        <div className='text-center'>
                                            <h3>Deposit</h3>
                                        </div>
                                        <div className='mb-5'>
                                            <div className="mb-3">
                                                <label className="form-label">Select Wallet</label>
                                                <select className="form-select form-control" aria-label="Default select example">
                                                    <option selected>0x6ac64618d6c82c1e51836658F9ca95885443e1cw</option>
                                                    <option value="1">0x6ac64618d6c82c1e51836658F9ca95885443e1cw</option>
                                                    <option value="2">0x6ac64618d6c82c1e51836658F9ca95885443e1cw</option>
                                                </select>
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Enter Amount</label>
                                                <input type="text" className="form-control" placeholder='Enter here' />
                                            </div>
                                        </div>
                                        <div className='modal_btn jc-center text-center'>
                                            <button className='btn cancel_btn me-4'>Cancel</button>
                                            <button className='btn deposit_btn'>Deposit</button>
                                        </div>
                                    </UserModal>
                                }
                                {
                                    // modalItem == "Withdraw" &&
                                    <UserModal btnText="Withdraw" id="Withdraw" customClasses="withdraw_btn" modalItem={modalItem} show={show} handleClose={handleClose} handleShow={handleShow} >
                                        <div className='text-center'>
                                            <h3>Withdraw</h3>
                                        </div>
                                        <div className='mb-5'>
                                            <div className="mb-3">
                                                <label className="form-label">Select Wallet</label>
                                                <select className="form-select form-control" aria-label="Default select example">
                                                    <option selected>0x6ac64618d6c82c1e51836658F9ca95885443e1cw</option>
                                                    <option value="1">0x6ac64618d6c82c1e51836658F9ca95885443e1cw</option>
                                                    <option value="2">0x6ac64618d6c82c1e51836658F9ca95885443e1cw</option>
                                                </select>
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Enter Amount</label>
                                                <input type="text" className="form-control" placeholder='Enter here' />
                                            </div>
                                        </div>
                                        <div className='modal_btn jc-center text-center'>
                                            <button className='btn cancel_btn me-4'>Cancel</button>
                                            <button className='btn deposit_btn'>Withdraw</button>
                                        </div>
                                    </UserModal>
                                }
                            </div>
                            <div>
                                <h6 style={{ color: "#413543" }}>Conversion</h6>
                                <div className='input d-flex jc-center ai-center'>
                                    <input type="number" value={maticAmount} onChange={handleMaticInputChange} className='form-control mb-4' placeholder='10' />
                                    <div className='purple d-flex jc-center ai-center'>
                                        <img src={matic} alt="icon" className='img-fluid me-2' />
                                        <p>Matic</p>
                                    </div>
                                </div>
                                <img src={arrows} alt="icon" className='img-fluid mb-4' />
                                <div className='input d-flex jc-center ai-center'>
                                    <input type="number" value={usdtAmount} onChange={handleUsdtInputChange} className='form-control' placeholder='10' />
                                    <div className='purple d-flex jc-center ai-center'>
                                        <img src={matic} alt="icon" className='img-fluid me-2' />
                                        <p>GBP</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Wallet
